const $ = require('cash-dom');

const QuickNav = {
  autoClose: true,
  hasScrolledFromTop: false,
  lastScrollY: 0, // Track previous scroll position

  init() {
    this.lastScrollY = window.scrollY;
    this._initQuickNav();
    this._initQuickNavMobile();
  },

  _initQuickNav() {
    const self = this, quickNavElement = document.querySelector('#quick_nav');
    if (!quickNavElement) return;

    const $quickNav = $(quickNavElement),
      listHolder = quickNavElement.querySelector('.quick-nav-list-holder'),
      $titleHolder = $quickNav.find('.quick-nav-title'),
      $titleHolderDynamic = $titleHolder.find('#quick-nav-title-dynamic'),
      originalTitle = $titleHolder.attr('data-title'),
      firstH2 = document.querySelector('h2');

    // Set max height for the list based on first 4 list items
    if (listHolder) {
      self._waitForRenderedHeight(listHolder, function () {
        const listItems = Array.from(listHolder.querySelectorAll('li')).slice(0, 4);
        const totalHeight = listItems.reduce((sum, li) => sum + li.offsetHeight, 0);
        const height = totalHeight - 2;

        if (height > 220) {
          listHolder.style.setProperty('max-height', `${height}px`, 'important');
        }
      });
    }

    // Toggle collapsed state on title click and update title text
    $titleHolder.on('click', function () {
      $quickNav.toggleClass('collapsed');
      self.autoClose = false;

      if ($quickNav.hasClass('collapsed')) {
        const $activeLink = $quickNav.find('li.active > a');
        if ($activeLink.length) {
          $titleHolderDynamic.text($activeLink.text());
        }
      } else {
        $titleHolderDynamic.text(originalTitle || '');
        self._recalculateQuickNavScroll($quickNav);
      }
    });

    // On scroll, auto-collapse menu and update active link & title
    window.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY;
      const scrollDown = currentScrollY > self.lastScrollY;
      self.lastScrollY = currentScrollY;

      if (window.scrollY > 100) {
        self.hasScrolledFromTop = true;
      }

      if (firstH2 && self.autoClose) {
        const y = firstH2.getBoundingClientRect().y, isAbove = y < 0;

        $quickNav.toggleClass('collapsed', isAbove);
        const $activeLink = $quickNav.find('li.active > a');

        if ($activeLink.length && $titleHolderDynamic.length) {
          $titleHolderDynamic.text(isAbove ? $activeLink.text() : originalTitle || '');
        }
      }

      // Update active link and title dynamically during scroll
      self._updateActiveLink($quickNav, originalTitle, $titleHolderDynamic, scrollDown);
    }, {passive: true});

    // On page load, set initial collapsed state and active link
    window.addEventListener('load', () => {
      if (firstH2 && firstH2.getBoundingClientRect().y < 0) {
        $quickNav.addClass('collapsed');
      }

      self._updateActiveLink($quickNav, originalTitle, $titleHolderDynamic, true);
    });
  },

  _updateActiveLink($quickNav, originalTitle, $titleHolderDynamic, scrollDown) {
    let activeUpdated = false,
      closestLink = null,
      closestDistance = Infinity;

    const self = this,
      links = $quickNav.find('li > a'),
      linkArray = Array.from(links);

    if (scrollDown) {
      linkArray.forEach(($a) => {
        const $currentA = $($a), id = $currentA.attr('href');
        if (!id || !id.startsWith('#')) return;

        const $section = $(id);
        if (!$section.length) return;

        const top = $section.get(0).getBoundingClientRect().top;

        if (top < 200 && top > -300 && !activeUpdated) {
          $quickNav.find('li').removeClass('active');
          $currentA.parent('li').addClass('active');

          $quickNav.hasClass('collapsed')
            ? $titleHolderDynamic.text($currentA.text())
            : $titleHolderDynamic.text(originalTitle || '');

          self._recalculateQuickNavScroll($quickNav);
          activeUpdated = true;
        }

        if (!self.hasScrolledFromTop) {
          const distance = Math.abs(top);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestLink = $currentA;
          }
        }
      });
    } else {
      const OFFSET = 20; // If 0, it will choose the previous heading (tested with 20 and works correctly)

      let closestTopAboveThreshold = Infinity;
      let closestLinkAboveThreshold = null;

      let bestTopBelowThreshold = -Infinity;
      let bestLinkBelowThreshold = null;

      linkArray.forEach(($a) => {
        const $currentA = $($a), id = $currentA.attr('href');
        if (!id || !id.startsWith('#')) return;

        const $section = $(id);
        if (!$section.length) return;

        const top = $section.get(0).getBoundingClientRect().top;

        if (top >= -OFFSET && top < closestTopAboveThreshold) {
          closestTopAboveThreshold = top;
          closestLinkAboveThreshold = $currentA;
        }

        // Find the closest heading whose top is above or within the OFFSET threshold
        if (top < -OFFSET && top > bestTopBelowThreshold) {
          bestTopBelowThreshold = top;
          bestLinkBelowThreshold = $currentA;
        }
      });

      // Choose the heading that is closest to the top but within the OFFSET,
      // or if none found, choose the last heading above the OFFSET
      const finalLink = closestLinkAboveThreshold || bestLinkBelowThreshold;

      if (finalLink) {
        $quickNav.find('li').removeClass('active');
        finalLink.parent('li').addClass('active');

        $quickNav.hasClass('collapsed')
          ? $titleHolderDynamic.text(finalLink.text())
          : $titleHolderDynamic.text(originalTitle || '');

        self._recalculateQuickNavScroll($quickNav);
        activeUpdated = true;
      }
    }
  },

  _recalculateQuickNavScroll($quickNav) {
    const listHolder = $quickNav.find('.quick-nav-list-holder');

    if (listHolder.length) {
      const $active = listHolder.find('.active');
      if (!$active.length) return;

      const activeTop = $active.get(0).offsetTop,
        holder = listHolder.get(0),
        holderHeight = holder.clientHeight,
        scrollTop = holder.scrollTop;

      // Scroll the list holder so the active item is visible
      if (activeTop < scrollTop || activeTop + $active.get(0).offsetHeight > scrollTop + holderHeight) {
        holder.scrollTo({top: activeTop, behavior: 'smooth'});
      }
    }
  },

  _waitForRenderedHeight(el, callback, maxTries = 10) {
    let tries = 0;
    function check() {
      const heightReady = el.offsetHeight > 0;
      if (heightReady || tries >= maxTries) {
        callback();
      } else {
        tries++;
        requestAnimationFrame(check);
      }
    }
    requestAnimationFrame(check);
  },

  _initQuickNavMobile() {
    const $quickNavMobile = $('#quick_nav_mobile');
    if (!$quickNavMobile.length) return;

    $quickNavMobile.on('click', function () {
      $(this).toggleClass('collapsed');
    });
  },
};

module.exports = QuickNav;